function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InboxModule from "./InboxModule";

class InboxResults extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderItem", (item, index) => {
      const _this$props = this.props,
            urlPattern = _this$props.urlPattern,
            moduleSize = _this$props.moduleSize,
            onSelect = _this$props.onSelect;
      return React.createElement(InboxModule, _extends({}, item, {
        urlPattern: urlPattern,
        moduleSize: moduleSize,
        onSelect: onSelect,
        key: index
      }));
    });
  }

  render() {
    const results = this.props.results;
    return React.createElement("div", {
      className: "admin-inbox__results"
    }, results.map(this.renderItem));
  }

}

_defineProperty(InboxResults, "defaultProps", {
  urlPattern: '/inbox/:uniqueId',
  results: []
});

InboxResults.propTypes = process.env.NODE_ENV !== "production" ? {
  urlPattern: PropTypes.string,
  moduleSize: PropTypes.string,
  root: PropTypes.string,
  results: PropTypes.array
} : {};
export default InboxResults;